export default function upperCaseFirst(text) {
  return text[0].toUpperCase() + text.slice(1);
}
